<template>
  <b-tabs pills content-class="mt-2 mb-4" v-if="value">
    <b-tab active>
      <template slot="title">
        Generale
        <b-badge variant="danger"
          v-if="countErrors()">
          {{ countErrors() }}
        </b-badge>
      </template>
      <form>
        <string-form-field
          label="Nome interno"
          :value="value.internalName"
          :disabled="disabled"
          :error="findError('internalName')"
          @input="propertyChanged('internalName', $event)"
        />

        <string-form-field
          label="Titolo"
          :value="value.title"
          :disabled="disabled"
          :error="findError('title')"
          @input="propertyChanged('title', $event)"
        />

        <taxonomy-form-field
          label="Tassonomie"
          :value="value.taxonomies"
          multiple
          :disabled="disabled"
          :error="findError('taxonomies')"
          @input="propertyChanged('taxonomies', $event)"
        />

        <number-form-field
          label="Colonne nascoste"
          :precision="0"
          :value="value.offset"
          :disabled="disabled"
          :error="findError('offset')"
          @input="propertyChanged('offset', $event)"
        />
      </form>
    </b-tab>
    <b-tab>
      <template slot="title">
        Input utente
        <b-badge variant="danger"
          v-if="countErrors('manualInput')">
          {{ countErrors('manualInput') }}
        </b-badge>
      </template>
      <form>
        <code-form-field
          :value="value.manualInput"
          :disabled="disabled"
          :error="findError('manualInput')"
          @input="propertyChanged('manualInput', $event)">
        </code-form-field>
      </form>
    </b-tab>
    <b-tab>
      <template slot="title">
        Formule
        <b-badge variant="danger"
          v-if="countErrors('formulas')">
          {{ countErrors('formulas') }}
        </b-badge>
      </template>
      <form>
        <code-form-field
          :value="value.formulas"
          :disabled="disabled"
          :error="findError('formulas')"
          @input="propertyChanged('formulas', $event)">
        </code-form-field>
      </form>
    </b-tab>
    <b-tab>
      <template slot="title">
        Presentazione
        <b-badge variant="danger"
          v-if="countErrors('presentation')">
          {{ countErrors('presentation') }}
        </b-badge>
      </template>
      <form>
        <code-form-field
          :value="value.presentation"
          :disabled="disabled"
          :error="findError('presentation')"
          @input="propertyChanged('presentation', $event)">
        </code-form-field>
      </form>
    </b-tab>
    <b-tab title="Riferimenti">
      <taxonomy-form-field
        label="Tassonomie"
        :disabled="disabled"
        @input="selectReference($event)"
      />

      <template v-if="taxonomyInfo">
        <display-table
            :value="taxonomyInfo.spReport"
            :columnClass="() => 'col-6'"
        />
        <display-table
            :value="taxonomyInfo.ceReport"
            :columnClass="() => 'col-6'"
        />
      </template>
    </b-tab>
    <b-tab title="Test">
      <form>
        <file-form-field
          @input="testFileChanged($event)">
        </file-form-field>

        <template v-if="testOutput">
          <display-table :value="testOutput" />
        </template>
      </form>
    </b-tab>
  </b-tabs>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';
import ReportService from 'app/services/ReportService';
import TaxonomyService from 'app/services/TaxonomyService';

export default {
  mixins: [ EntityEditorMixin ],

  data() {
    return {
      taxonomyInfo: null,
      testOutput: null,
    };
  },

  methods: {
    testFileChanged(file) {
      console.log('Test file changed', file);

      const progress = (loaded, total) => {
        console.log('Upload progress: ', loaded * 100 / total, '%');
      }

      const success = ({ statusCode, data }) => {
        console.log('File correctly processed:', statusCode, data);
        this.testOutput = data;
      };

      const error = ({ statusCode, data }) => {
        console.log('File processing error:', statusCode, data);
      };

      ReportService.test({ instance: this.value, file, progress })
          .then(success, error);
    },

    selectReference(date) {
      console.log('taxonomyDate', date);

      const success = ({ statusCode, data }) => {
        this.taxonomyInfo = data;
      };

      const error = ({ statusCode, data }) => {
        console.log('Error loading taxonomy', statusCode, data);
      };

      TaxonomyService.load({ date, type: 'ese' })
          .then(success, error);
    }
  }
}
</script>
